import React from "react";

const ListMarchantTableHead = (props) => {
  return (
    <tr>
      {props.viewAccess !== "ViewDashboard" ? (
        <th style={{ width: "10%" }}>
          {/* <input
            type="radio"
            id="restaurants"
            name="restaurants"
           // onChange={props.restaurantsOnChange}
            value={props.exp}
            // checked={props.selectedCheck ? true : false}
          /> */}
        </th>
      ) : null}
      <th
        className="f10-500"
        style={{ width: props.viewAccess !== "ViewDashboard" ? "23%" : "20%" }}
      >
        ID
      </th>
      <th
        className="f10-500"
        style={{ width: props.viewAccess !== "ViewDashboard" ? "18%" : "20%" }}
      >
        Experience
        <br />
        Name
      </th>
      <th className="f10-500" style={{ width: "20%" }}>
      Experience Description
      </th>
      <th className="f10-500" style={{ width: "10%" }}>
        City
      </th>
      <th className="f10-500" style={{ width: "10%" }}>
        experience/
        <br />
       Id
      </th>
      <th
        className="f10-500"
        style={{ width: props.viewAccess !== "ViewDashboard" ? "10%" : "16%" }}
      >
        Images/ Video
      </th>
    </tr>
  );
};

export default ListMarchantTableHead;
